import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockPRs } from '../data/mockData';
export function NOAList() {
  const navigate = useNavigate();
  // Filter for approved PRs that aren't Cash Purchase
  const data = mockPRs.filter(pr => pr.status === 'Approved' && pr.procurementMethod !== 'Cash Purchase');
  const columns: Column<any>[] = [{
    key: 'prNo',
    label: 'PR No',
    render: pr => <span className="font-medium text-indigo-600" data-id="element-1403">{pr.prNo}</span>
  }, {
    key: 'originator',
    label: 'Originator'
  }, {
    key: 'requisitionFor',
    label: 'Requisition For'
  }, {
    key: 'procurementMethod',
    label: 'Method'
  }, {
    key: 'total',
    label: 'Total Amount',
    render: pr => `$${pr.total.toLocaleString()}`
  }, {
    key: 'status',
    label: 'PR Status',
    render: pr => <StatusBadge status={pr.status} data-id="element-1404" />
  }, {
    key: 'noaStatus',
    label: 'NOA Status',
    render: () => <StatusBadge status="Draft" data-id="element-1405" /> // Mock status
  }, {
    key: 'actions',
    label: 'Action',
    render: pr => <button onClick={() => navigate(`/noa/${pr.id}`)} className="text-indigo-600 hover:text-indigo-900 font-medium text-sm" data-id="element-1406">
          Process NOA
        </button>
  }];
  return <div className="space-y-6 h-full flex flex-col pb-8" data-id="element-1407">
      <div className="flex items-center justify-between" data-id="element-1408">
        <div data-id="element-1409">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1410">
            Notice of Award (NOA)
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1411">
            Process NOA for requisitions that have completed their RFP/RFQ
            phase.
          </p>
        </div>
      </div>

      <div className="flex-1 bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden flex flex-col" data-id="element-1412">
        <div className="flex-1 p-0" data-id="element-1413">
          <DataTable columns={columns} data={data} keyExtractor={item => item.id} searchPlaceholder="Search PRs..." data-id="element-1414" />
        </div>
      </div>
    </div>;
}